export class NativeStreamScalarOutputType {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "type",
            "baseName": "type",
            "type": "NativeStreamScalarOutputKind",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamScalarOutputType.attributeTypeMap;
    }
    constructor() {
    }
}
